import Vue from 'vue'
import Router from 'vue-router'
/*import AdminOrderGrid from '../../customerhub-spa/src/views/admin/OrderGrid.vue';*/
import InstantMarketingHome from './views/instant_marketing/HomeIM.vue'
import InstantMarketingFulfilment from './views/instant_marketing/FulfilmentIM.vue'
import InstantMarketingData from './views/instant_marketing/PreviewData.vue'
import InstantMarketingTemplateType from './views/instant_marketing/SelectTemplateType.vue'
import InstantMarketingTemplate from './views/instant_marketing/SelectTemplate.vue'
import InstantMarketingPersonaliseDesign from './views/instant_marketing/PersonaliseDesign.vue'
import InstantMarketingPersonaliseDesignAdvanced from './views/instant_marketing/PersonaliseDesignAdvanced.vue'
import InstantMarketingPreviewDesign from './views/instant_marketing/PreviewDesign.vue'
import PrintOptionsIM from './views/instant_marketing/PrintOptionsIM.vue'
import CheckoutIM from './views/instant_marketing/CheckoutIM.vue'
import ConfirmationIM from './views/instant_marketing/ConfirmationIM.vue'
import InstantMarketingSelectDataDatabook from './views/instant_marketing/SelectDataDatabook.vue'
import InstantMarketingSelectDataLeadhub from './views/instant_marketing/SelectDataLeadhub.vue'
import InstantMarketingOrders from './views/instant_marketing/Orders.vue'
import InstantMarketingProfile from './views/instant_marketing/Profile.vue'
import InstantMarketingTemplates from './views/instant_marketing/Templates.vue'
import InstantMarketingEditTemplate from './views/instant_marketing/EditTemplate.vue'
import InstantMarketingCreateAccount from './views/instant_marketing/CreateAccount.vue'
import InstantMarketingPageflex from './views/instant_marketing/Pageflex.vue'

Vue.use(Router)

//export default new Router({
const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        /*{
            path: '/admin/orders',
            name: '/admin/orders',
            component: AdminOrderGrid,
            props: true
        },*/
        {
            path: '/',
            name: 'InstantMarketingHome',
            component: InstantMarketingHome,
            props: true
        },
        {
            path: '/fulfilment',
            name: 'InstantMarketingFulfilment',
            component: InstantMarketingFulfilment,
            props: true
        },
        {
            path: '/data-preview',
            name: 'InstantMarketingData',
            component: InstantMarketingData,
            props: true
        },
        {
            path: '/select-design-type',
            name: '/select-design-type',
            component: InstantMarketingTemplateType,
            props: true
        },
        {
            path: '/select-design',
            name: '/select-design',
            component: InstantMarketingTemplate,
            props: true
        },
        {
            path: '/personalise-design',
            name: 'InstantMarketingPersonaliseDesign',
            component: InstantMarketingPersonaliseDesign,
            props: true
        },
        {
            path: '/personalise-design-advanced',
            name: 'InstantMarketingPersonaliseDesignAdvanced',
            component: InstantMarketingPersonaliseDesignAdvanced,
            props: true
        },
        {
            path: '/preview-design',
            name: 'InstantMarketingPreviewDesign',
            component: InstantMarketingPreviewDesign,
            props: true
        },
        {
            path: '/print-options',
            name: 'PrintOptionsIM',
            component: PrintOptionsIM,
            props: true
        },
        {
            path: '/checkout',
            name: 'CheckoutIM',
            component: CheckoutIM,
            props: true
        },
        {
            path: '/confirmation',
            name: 'ConfirmationIM',
            component: ConfirmationIM,
            props: true
        },
        {
            path: '/select-data-databook',
            name: '/select-data-databook',
            component: InstantMarketingSelectDataDatabook,
            props: true
        },
        {
            path: '/select-data-leadhub',
            name: '/select-data-leadhub',
            component: InstantMarketingSelectDataLeadhub,
            props: true
        },
        {
            path: '/orders',
            name: 'InstantMarketingOrders',
            component: InstantMarketingOrders,
            props: true
        },
        {
            path: '/profile',
            name: 'InstantMarketingProfile',
            component: InstantMarketingProfile,
            props: true
        },
        {
            path: '/templates',
            name: 'InstantMarketingTemplates',
            component: InstantMarketingTemplates,
            props: true
        },
        {
            path: '/edit-template',
            name: 'InstantMarketingEditTemplate',
            component: InstantMarketingEditTemplate,
            props: true
        },
        {
            path: '/createAccount',
            name: 'InstantMarketingCreateAccount',
            component: InstantMarketingCreateAccount,
            props: true
        },
        {
            path: '/pageflex',
            name: 'InstantMarketingPageflex',
            component: InstantMarketingPageflex,
            props: true
        },
    ]
})

export default router
